<template>
  <table class="table table-striped mypage-reserve-table">
    <slot name="thead"></slot>
    <tbody>
      <tr v-for="data in cellData" :key="data.id" class="trFlex">
        <template v-if="data.arrayType === 'playStyle'">
            <td class="font-weight-bold">プレースタイル</td>
            <td>
                <Icon :iconFlg="data.value" :dispType="data.arrayType" class="sp_play_style"/>
            </td>
        </template>
        <!-- リクエスト予約時希望表示 -->
        <template v-else-if="data.arrayType === 'requestChoice'">
            <td class="font-weight-bold">{{ data.name }}</td>
            <td>
              <p v-for="(i, index) of data.value" :key="i.id">
                第{{ index + 1 }}希望:{{ i }}
              </p>
            </td>
        </template>
        <!-- 通常時 -->
        <template v-else>
            <td class="font-weight-bold">{{ data.name }}</td>
            <td class="whitespace" :class="data.class">{{ data.value }}</td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { GET_CODE_KEY_LIST } from '../../constants/codelist';
import Icon from './Icon';
export default {
    components: {
        Icon
    },
    props: {
        cellData: {
            Type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.table td{
    word-break: break-all;
    vertical-align: inherit;
    border-top: none;
}
.whitespace{
    white-space: pre-line;
}
.sp_play_style {
    justify-content: flex-start;
    display: flex;
    align-items: center;
}
@media screen and (max-width: 896px) {
    .sp_play_style {
        justify-content: flex-end;
    }
}
</style>
